import { Snackbar, Alert, styled } from "@mui/material";
import { useBreakpoints } from "../hooks/BreakpointsHook";
import pic from "../image1.png";
import React, { useState, useEffect } from 'react';
import { initializeApp} from "firebase/app";
import { getDatabase, ref, set, child, get } from "firebase/database";
import { addDoc, collection } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";




const MiddleContainer = styled("div")((props) => ({
    display: "flex",
    flexDirection: props.isMd || props.isSm || props.isXs ? "column" : "row",
    alignItems: props.isMd || props.isSm || props.isXs ? "center" : "stretch",  // Adjusted this line
    //height: "100%",
    width: "100%",
    boxSizing: 'border-box',
    padding: props.isMd || props.isSm || props.isXs ? "0px 50px" : "0px 170px",
    borderTop: "1px solid rgba(0, 0, 0, 0.20)",
    flex: "1 0 auto",
    justifyContent: "center",
}));

const ImageContainer = styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,  // This will make it take up the available space
});



const Img = styled("img")((props) => ({
    width: props.isXs ? "262.125px" : (props.isMd || props.isSm) ? "349.5px" : "466px",
    height: props.isXs ? "180.5625px" : (props.isMd || props.isSm) ? "240.75px" : "321px",
    flex: "none",
    order: 0,
    flexGrow: 0,
    margin: (props.isMd || props.isSm || props.isXs) ? "auto" : "0",
}));



const ContentContainer = styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    width: "100%",
});

const Title = styled("h2")({
    color: "#000",
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "48px",
    alignSelf: "stretch",
    margin: "0",  // Set margin to zero
});

const SmallerContainer = styled("div")({
    display: "flex",
    paddingTop: "20px",
    alignItems: "flex-start",
    alignContent: "flex-start",
    alignSelf: "stretch",
    flexWrap: "wrap",
    background: "#FFF",
    // Add any other styles for the SmallerContainer here
});


const EmailInput = styled("input")((props) => ({
    display: "flex",
    height: "36px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    flex: "1 0 0",
    padding: "0",
    textAlign: "center",
    border: "1px solid #000",
    outline: "none",
    boxSizing: "border-box",
    fontSize: props.isMd || props.isSm || props.isXs ? "10px" : "12px",  // Adjust font size based on screen size
}));

const SubmitButton = styled("button")({
    display: "flex",
    height: "36px",
    padding: "12px 0px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0 0",
    background: "#000",
    color: "#FFF",
    border: "none",
    cursor: "pointer",
    boxSizing: "border-box",  // Ensure padding and border are included in the total height
    // Add any other styles for the button here
});


export default function Middle() {
    const [database, setDatabase] = useState(null);
    const { isXs, isSm, isMd, isLg, isXl } = useBreakpoints();
    const [email, setEmail] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    

    useEffect(() => {
        const firebaseConfig = {
            apiKey: "AIzaSyALM-uBBPPQ1BmuPeUXyfKgjvbtZfGML08",
            authDomain: "boltfinance-2aa63.firebaseapp.com",
            projectId: "boltfinance-2aa63",
            storageBucket: "boltfinance-2aa63.appspot.com",
            messagingSenderId: "580511161853",
            appId: "1:580511161853:web:580faf7917c35c143c4d94",
            measurementId: "G-V3WPLHNHPX",
            databaseURL: "https://boltfinance-2aa63-default-rtdb.asia-southeast1.firebasedatabase.app",

        };
        
        const app = initializeApp(firebaseConfig);
        const dbInstance = getDatabase(app);
        const dbRef = ref(dbInstance);
        setDatabase(dbInstance);
    }, []);
        



    const handleSubmit = () => {
        const currentUTCDate = new Date().toISOString().split('.')[0] + 'Z';
        console.log("currentUTCDate", currentUTCDate);
        console.log("email", email);
        console.log(`Submitting email: ${email}`);
        console.log("database", database)
        set(ref(database, '/' + currentUTCDate), email);
        // TODO: Add logic to submit the email to your database

        setOpenSnackbar(true); // Show the Snackbar

        // Hide the Snackbar after 5 seconds
        setTimeout(() => {
            setOpenSnackbar(false);
        }, 5000);
    };

    return (
        <MiddleContainer isXs={isXs} isSm={isSm} isMd={isMd} isLg={isLg} isXl={isXl}>
            <ImageContainer>
                <Img src={pic} alt="Layer" isXs={isXs} isSm={isSm} isMd={isMd} isLg={isLg} isXl={isXl} />
            </ImageContainer>
            <ContentContainer>
                <Title>Join the Waitlist</Title>
                <SmallerContainer>
                    <EmailInput 
                        type="email" 
                        placeholder="Enter your email address" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        isXs={isXs} isSm={isSm} isMd={isMd}
                    />
                    <SubmitButton onClick={handleSubmit}>
                        Join Waitlist
                    </SubmitButton>
                </SmallerContainer>
            </ContentContainer>
            {/* Snackbar component */}
            <Snackbar 
                open={openSnackbar} 
                autoHideDuration={5000} 
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity="success">Thanks - you're on the waitlist!</Alert>
            </Snackbar>
        </MiddleContainer>
    );
}
